module.exports = __webpack_public_path__ + "img/green_113.8b4c202d.png";